import React, { useContext } from "react";
import { Button } from "@mui/material";
import { BASE_URL } from "../../global.js";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig.js";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { DatasheetContext } from "./datasheet.context.js";
import { styled } from "@mui/material/styles";
import { toast } from "react-toastify";

const VisuallyHiddenInput = styled("input")`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;

const DatasheetImages = () => {
  const datasheetContextValue = useContext(DatasheetContext);
  const { state: { fileAttachment }, dispatch, } = datasheetContextValue;

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const data = new FormData();
    data.append("fileToUpload", file);

    // dispatch({
    //   field: "fileAttachment",
    //   value: ["https://bipl.bfiinfotech.co.in/api/fileUpload/uploads/1774336290__AE_25-26_6_1.pdf"],
    // });

    axiosWithToken
      .post(BASE_URL + "fileUpload/fileUpload.php", data)
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            field: "fileAttachment",
            value: [res.data],
          });

          toast.success("File Uploaded Successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((err) => {
       console.log("err", err)
      });
  };

  return (
    <div>
      <div style={{display: "flex", alignItems: "center", marginBottom: "20px", gap: "20px",}}>
        <Button
          component="label"
          variant="contained"
          startIcon={<CloudUploadIcon />}
          size="small"
          style={{ float: "left" }}
        >
          Upload File
          <VisuallyHiddenInput type="file" onChange={handleFileUpload} />
        </Button>
        {fileAttachment && fileAttachment.length > 0 && (
            <a href={fileAttachment} target="_blank" rel="noopener noreferrer">
              View File
            </a>
        )}
      </div>{" "}
    </div>
  );
};

export default DatasheetImages;
